<!--School Select-->
<div class="SelectorBar">
	<label>User Groups for School:</label>
	<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
    [(ngModel)]="SchoolID"
    (ngModelChange)="onSchoolChange($event)">
        <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
    </select> -->

	<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
</div>

<!--Main Table-->
<!--Table-->
<div class="InnerMenu table-main-body">
	<caass-user-group-table [AllowDistrictGroups]="AllowDistrictGroups" [SchoolID]="SchoolID" CanEdit="true" (GroupSelected)="onGroupSelected($event)">
	</caass-user-group-table>
</div>

<!--Lower Table Grid-->
<div class="Grid2Col MarginTop">
	<!--Left Col, Role Table-->
	<div class="InnerMenu">
		<caass-user-group-role-table [SchoolID]="SchoolID" [SelectedUserGroup]="SelectedUserGroup"> </caass-user-group-role-table>
	</div>

	<!--Right Col, Users Table-->
	<div class="InnerMenu">
		<caass-user-group-user-table [SchoolID]="SchoolID" [SelectedUserGroup]="SelectedUserGroup"> </caass-user-group-user-table>
	</div>
</div>
